<div class="bgcomp h-100 pl-3 py-3 position-relative">
  <div
    id="dialog-header"
    mat-dialog-title
    class="drag-handle-header"
    cdkDrag
    cdkDragRootElement=".draggable-dialog-container.imaging-request-form-dialog"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    [cdkDragDisabled]="mouseOverSearchTermControl"
  >
    <h2>Request Details</h2>

    @if(showSearch$ | async) {
    <div class="search">
      <div class="pr-2 search-question-icon">
        <div class="search-question-icon-tooltip">
          Search by patient first name, surname, or hospital number
        </div>
        <span class="material-icons">help</span>
      </div>
      <form [formGroup]="searchForm">
        <input
          [ngClass]="{ active: (hasSearchTerm$ | async) }"
          placeholder="Patient Search"
          formControlName="searchTerm"
          class="search-input"
          autocomplete="off"
          id="new-imaging-request-search"
          (mouseenter)="onMouseEnterSearchTermControl()"
          (mouseleave)="onMouseLeaveSearchTermControl()"
          (keydown.enter)="submitSearch($event)"
        />
        <button
          (click)="submitSearch($event)"
          *ngIf="(hasSearchTerm$ | async) === false"
          class="search-button"
          id="integrated-referral-search-button"
          mat-icon-button
          matSuffix
        >
          <mat-icon class="mat-evericon">search</mat-icon>
        </button>
        <button
          (click)="clearSearch()"
          *ngIf="hasSearchTerm$ | async"
          class="search-button"
          id="integrated-referral-search-clear-button"
          mat-icon-button
          matSuffix
        >
          <mat-icon class="mat-evericon">close</mat-icon>
        </button>
      </form>
    </div>
    }
    <button
      [ngClass]="{ 'ml-0': (showSearch$ | async) }"
      mat-button
      (click)="close()"
      id="close-icon"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if(hasSearchTerm$ | async) {
  <app-patient-search-list
    [protoReferralList]="patientSearchResults$()"
    (clearSearch)="clearSearch()"
    (loadPatientData)="onLoadIntegratedProtoReferral($event)"
  ></app-patient-search-list>
  }
  <form
    [ngClass]="{ 'hide-form': hasSearchTerm$ | async }"
    [formGroup]="imagingRequestForm"
  >
    <mat-dialog-content class="custom-scrollbar overflow-auto m-0 p-0">
      <div class="row no-gutters panel-row panel-row">
        <div class="col col-patient">
          <div class="section section-patient">
            <h4 class="section-header dotted-underline">Patient</h4>
            <div class="row section-body d-flex" formGroupName="patient">
              <div class="col label-and-input d-flex flex-column">
                <label for="patient-first-name">Patient First Name *</label>
                <input
                  formControlName="firstName"
                  id="patient-first-name"
                  type="text"
                />
                @if(patientForm.controls.firstName?.touched ||
                patientForm.controls.firstName?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="patientForm.controls.firstName?.errors?.['maxlength'] as maxLengthError"
                  >
                    Patient First Name cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(patientForm.controls.firstName?.errors?.['required']) {
                  <p>Patient First Name is required</p>
                  } @if(patientForm.controls.firstName?.errors?.['whitespace'])
                  {
                  <p>Patient First Name cannot be whitespace</p>
                  } @if(patientForm.controls.firstName?.errors?.['pattern']) {
                  <p>Invalid characters in Patient First Name</p>
                  }
                </div>
                }
              </div>
              <div class="col label-and-input d-flex flex-column">
                <label for="patient-surname">Patient Surname *</label>
                <input
                  formControlName="surname"
                  id="patient-surname"
                  type="text"
                />
                @if(patientForm.controls.surname?.touched ||
                patientForm.controls.surname?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="patientForm.controls.surname?.errors?.['maxlength'] as maxLengthError"
                  >
                    Patient Surname cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(patientForm.controls.surname?.errors?.['required']) {
                  <p>Patient Surname is required</p>
                  } @if(patientForm.controls.surname?.errors?.['whitespace']) {
                  <p>Patient Surname cannot be whitespace</p>
                  } @if(patientForm.controls.surname?.errors?.['pattern']) {
                  <p>Invalid characters in Patient Surname</p>
                  }
                </div>
                }
              </div>
              <div class="col label-and-input">
                <label for="patient-dob">Date of Birth*</label>
                <div class="date-input-wrapper">
                  <input
                    matInput
                    id="patient-dob"
                    formControlName="dob"
                    [matDatepicker]="datePicker"
                    [matDatepickerFilter]="isDateBeforeToday"
                    placeholder="DD/MM/YYYY"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #datePicker></mat-datepicker>
                </div>
                @if(patientForm.controls.dob?.touched ||
                patientForm.controls.dob?.dirty) {
                <div class="invalid-feedback">
                  @if(patientForm.controls.dob?.errors?.['required']) {
                  <p>Date of Birth is missing or has formatting issues</p>
                  }
                  @if(patientForm.controls.dob?.errors?.['matDatepickerFilter'])
                  {
                  <p>Future date is not allowed</p>
                  }
                </div>
                }
              </div>
              <div class="col label-and-input d-flex flex-column">
                <label for="patient-location">Patient Location *</label>
                <input
                  formControlName="location"
                  id="patient-location"
                  type="text"
                />
                @if(patientForm.controls.location?.touched ||
                patientForm.controls.location?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="patientForm.controls.location?.errors?.['maxlength'] as maxLengthError"
                  >
                    Patient Location cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(patientForm.controls.location?.errors?.['required']) {
                  <p>Patient Location is required</p>
                  } @if(patientForm.controls.location?.errors?.['whitespace']) {
                  <p>Patient Location cannot be whitespace</p>
                  } @if(patientForm.controls.location?.errors?.['pattern']) {
                  <p>Invalid characters in Patient Location</p>
                  }
                </div>
                }
              </div>
              <div class="col label-and-input d-flex flex-column">
                <label for="patient-hospital-number">Hospital Number *</label>
                <input
                  formControlName="hospitalNumber"
                  id="patient-hospital-number"
                  type="text"
                />
                @if(patientForm.controls.hospitalNumber?.touched ||
                patientForm.controls.hospitalNumber?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="patientForm.controls.hospitalNumber?.errors?.['maxlength'] as maxLengthError"
                  >
                    Hospital Number cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(patientForm.controls.hospitalNumber?.errors?.['required'])
                  {
                  <p>Hospital Number is required</p>
                  }
                  @if(patientForm.controls.hospitalNumber?.errors?.['whitespace'])
                  {
                  <p>Hospital Number cannot be whitespace</p>
                  }
                  @if(patientForm.controls.hospitalNumber?.errors?.['pattern'])
                  {
                  <p>Invalid characters in Hospital Number</p>
                  }
                </div>
                }
              </div>
              <div class="col label-and-input d-flex flex-column">
                <label for="siteMenu">Site *</label>
                <div class="site">
                  <button
                    mat-button
                    id="site-selection-button"
                    type="button"
                    [disabled]="!siteSelectionEnabled"
                    [matMenuTriggerFor]="siteMenu"
                    [ngClass]="selectedSite === null ? 'placeholder' : ''"
                  >
                    <div class="d-flex justify-content-between">
                      <p class="align-self-end">
                        {{
                          selectedSite ? selectedSite.siteName : 'Select Site'
                        }}
                      </p>
                      @if (siteSelectionEnabled) {
                      <fa-icon
                        class="align-self-center ml-2"
                        id="site-selection-dropdown-icon"
                        [icon]="['fas', 'caret-down']"
                        size="lg"
                      ></fa-icon>
                      }
                    </div>
                  </button>
                  <mat-menu
                    #siteMenu="matMenu"
                    class="selection-pane primary-menu"
                  >
                    @for (site of allowedSites; track $index) {
                    <div
                      mat-menu-item
                      id="site-{{ site?.siteId }}"
                      (click)="selectSite(site)"
                      [ngClass]="{
                        active: site?.siteId === selectedSite?.siteId
                      }"
                    >
                      <p class="text-ellipsis">{{ site?.siteName }}</p>
                    </div>
                    }
                  </mat-menu>
                  @if (patientForm.controls.site?.touched ||
                  patientForm.controls.site?.dirty) {
                  <div class="invalid-feedback">
                    @if(patientForm.controls.site?.errors?.['required']) {
                    <p>Site selection is required</p>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-requested-by">
          <div class="section section-requested-by">
            <h4 class="section-header dotted-underline">Requested by</h4>
            <div class="row section-body" formGroupName="requestedBy">
              <div class="col d-flex flex-column label-and-input">
                <label for="clinician-first-name">Clinician Name *</label>
                <input
                  formControlName="clinicianName"
                  id="clinician-first-name"
                  type="text"
                />
                @if(requestedByForm.controls.clinicianName?.touched ||
                requestedByForm.controls.clinicianName?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="requestedByForm.controls.clinicianName?.errors?.['maxlength'] as maxLengthError"
                  >
                    Clinician Name cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(requestedByForm.controls.clinicianName?.errors?.['required'])
                  {
                  <p>Clinician Name is required</p>
                  }
                  @if(requestedByForm.controls.clinicianName?.errors?.['whitespace'])
                  {
                  <p>Clinician Name cannot be whitespace</p>
                  }
                  @if(requestedByForm.controls.clinicianName?.errors?.['pattern'])
                  {
                  <p>Invalid characters in Clinician Name</p>
                  }
                </div>
                }
              </div>
              <div class="col d-flex flex-column label-and-input">
                <label for="clinician-phone-number">Phone Number *</label>
                <input
                  formControlName="clinicianPhoneNumber"
                  id="clinician-phone-number"
                  type="text"
                />
                @if(requestedByForm.controls.clinicianPhoneNumber?.touched ||
                requestedByForm.controls.clinicianPhoneNumber.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="requestedByForm.controls.clinicianPhoneNumber?.errors?.['maxlength'] as maxLengthError"
                  >
                    Phone Number cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(requestedByForm.controls.clinicianPhoneNumber?.errors?.['required'])
                  {
                  <p>Phone Number is required</p>
                  }
                  @if(requestedByForm.controls.clinicianPhoneNumber?.errors?.['whitespace'])
                  {
                  <p>Phone Number cannot be whitespace</p>
                  }
                  @if(requestedByForm.controls.clinicianPhoneNumber?.errors?.['pattern'])
                  {
                  <p>Invalid characters in Phone Number</p>
                  }
                </div>
                }
              </div>
              <div class="col d-flex flex-column label-and-input">
                <label class="wide-label" for="authority-to-request-scans"
                  >Authority to request scans</label
                >
                <mat-radio-group
                  id="authority-to-request-scans"
                  formControlName="authorityToRequestScans"
                >
                  <mat-radio-button class="label mr-4" [value]="true"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button class="label" [value]="false"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
                @if(requestedByForm.controls.authorityToRequestScans?.touched ||
                requestedByForm.controls.authorityToRequestScans?.dirty) {
                <div class="invalid-feedback">
                  @if(requestedByForm.controls.authorityToRequestScans?.errors?.['required'])
                  {
                  <p>Authority to request scans is required</p>
                  }
                </div>
                }
              </div>
              @if(requestedByForm.controls.authorityToRequestScans.value ===
              false) {
              <div class="col d-flex flex-column label-and-input">
                <label for="clinician-requested-by">Approved By *</label>
                <input
                  formControlName="requestedBy"
                  id="clinician-requested-by"
                  type="text"
                />
                @if(requestedByForm.controls.requestedBy?.touched ||
                requestedByForm.controls.requestedBy?.dirty) {
                <div class="invalid-feedback">
                  <p
                    *ngIf="requestedByForm.controls.requestedBy?.errors?.['maxlength'] as maxLengthError"
                  >
                    Approved By cannot be more than
                    {{ maxLengthError.requiredLength }} characters
                  </p>
                  @if(requestedByForm.controls.requestedBy?.errors?.['required'])
                  {
                  <p>Approved By is required</p>
                  }
                  @if(requestedByForm.controls.requestedBy?.errors?.['whitespace'])
                  {
                  <p>Approved By cannot be whitespace</p>
                  }
                  @if(requestedByForm.controls.requestedBy?.errors?.['pattern'])
                  {
                  <p>Invalid characters in Approved By</p>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters panel-row">
        <div class="col col-medical-history">
          <div class="section section-patient-medical-history">
            <div
              class="d-flex dotted-underline"
              formGroupName="patientMedicalHistory"
            >
              <h4 class="section-header flex-grow-1">
                Patient Medical History
              </h4>
              <div class="contrast-allergy mr-3">
                <button
                  type="button"
                  mat-button
                  [matMenuTriggerFor]="contrastAllergyMenu"
                  [ngClass]="
                    ContrastAllergyDropdownMapping.get(
                      medicalHistoryForm.controls.contrastAllergy.value
                    )?.backgroundColor ?? 'none'
                  "
                >
                  <div class="d-flex justify-content-between">
                    <p class="align-self-end">
                      {{
                        ContrastAllergyDropdownMapping.get(
                          medicalHistoryForm.controls.contrastAllergy.value
                        )?.display ??
                          medicalHistoryForm.controls.contrastAllergy.value
                      }}
                    </p>
                    <fa-icon
                      class="align-self-center ml-2"
                      [icon]="['fas', 'caret-down']"
                      size="lg"
                    ></fa-icon>
                  </div>
                </button>
                <mat-menu
                  #contrastAllergyMenu="matMenu"
                  class="selection-pane primary-menu"
                >
                  @for(contrastAllergyOption of contrastAllergyDropdownOptions;
                  track contrastAllergyOption.value) {
                  <div
                    mat-menu-item
                    id="contrast-allergy-{{
                      contrastAllergyOption.value.toLowerCase()
                    }}"
                    (click)="setContrastAllergy(contrastAllergyOption.value)"
                    [ngClass]="{
                      active:
                        contrastAllergyOption.value ===
                        medicalHistoryForm.controls.contrastAllergy.value
                    }"
                  >
                    <p class="text-ellipsis">
                      {{ contrastAllergyOption.display }}
                    </p>
                  </div>
                  }
                </mat-menu>
                @if(medicalHistoryForm.controls.contrastAllergy?.touched ||
                medicalHistoryForm.controls.contrastAllergy?.dirty) {
                <div class="invalid-feedback">
                  @if(medicalHistoryForm.controls.contrastAllergy?.errors?.['defaultDropdownValue'])
                  {
                  <p>Contrast Allergy selection is required</p>
                  }
                </div>
                }
              </div>
              <div class="pregnancy">
                <button
                  type="button"
                  mat-button
                  [matMenuTriggerFor]="pregnancyMenu"
                  [ngClass]="
                    PregnancyDropdownMapping.get(
                      medicalHistoryForm.controls.pregnancy.value
                    )?.backgroundColor ?? 'none'
                  "
                >
                  <div class="d-flex justify-content-between">
                    <p class="align-self-end">
                      {{
                        PregnancyDropdownMapping.get(
                          medicalHistoryForm.controls.pregnancy.value
                        )?.display ??
                          medicalHistoryForm.controls.pregnancy.value
                      }}
                    </p>
                    <fa-icon
                      class="align-self-center ml-2"
                      [icon]="['fas', 'caret-down']"
                      size="lg"
                    ></fa-icon>
                  </div>
                </button>
                <mat-menu
                  #pregnancyMenu="matMenu"
                  class="selection-pane primary-menu"
                >
                  @for(pregnancyOption of pregnancyDropdownOptions; track
                  pregnancyOption.value) {
                  <div
                    mat-menu-item
                    id="pregnancy-{{ pregnancyOption.value.toLowerCase() }}"
                    (click)="setPregnancy(pregnancyOption.value)"
                    [ngClass]="{
                      active:
                        pregnancyOption.value ===
                        medicalHistoryForm.controls.pregnancy.value
                    }"
                  >
                    <p class="text-ellipsis">{{ pregnancyOption.display }}</p>
                  </div>
                  }
                </mat-menu>
                @if(medicalHistoryForm.controls.pregnancy?.touched ||
                medicalHistoryForm.controls.pregnancy?.dirty) {
                <div class="invalid-feedback">
                  @if(medicalHistoryForm.controls.pregnancy?.errors?.['defaultDropdownValue'])
                  {
                  <p>Pregnancy selection is required</p>
                  }
                </div>
                }
              </div>
            </div>
            <div class="row section-body">
              <div class="col col-medical-notes">
                <div class="row flex-column no-gutters">
                  <div
                    class="d-flex flex-column label-and-input"
                    formGroupName="patientMedicalHistory"
                  >
                    <label for="differential-diagnosis"
                      >Differential Diagnosis *</label
                    >
                    <input
                      formControlName="differentialDiagnosis"
                      id="differential-diagnosis"
                      type="text"
                    />
                    @if(medicalHistoryForm.controls.differentialDiagnosis?.touched
                    || medicalHistoryForm.controls.differentialDiagnosis?.dirty)
                    {
                    <div class="invalid-feedback">
                      <p
                        *ngIf="medicalHistoryForm.controls.differentialDiagnosis?.errors?.['maxlength'] as maxLengthError"
                      >
                        Differential Diagnosis cannot be more than
                        {{ maxLengthError.requiredLength }} characters
                      </p>
                      @if(medicalHistoryForm.controls.differentialDiagnosis?.errors?.['required'])
                      {
                      <p>Differential Diagnosis is required</p>
                      }
                      @if(medicalHistoryForm.controls.differentialDiagnosis?.errors?.['whitespace'])
                      {
                      <p>Differential Diagnosis cannot be whitespace</p>
                      }
                      @if(medicalHistoryForm.controls.differentialDiagnosis?.errors?.['pattern'])
                      {
                      <p>Invalid characters in Differential Diagnosis</p>
                      }
                    </div>
                    }
                  </div>
                  <div
                    class="d-flex flex-column label-and-input"
                    formGroupName="patientMedicalHistory"
                  >
                    <label for="clinical-history">Clinical History *</label>
                    <textarea
                      formControlName="clinicalHistory"
                      id="clinical-history"
                      rows="5"
                    ></textarea>
                    @if(medicalHistoryForm.controls.clinicalHistory?.touched ||
                    medicalHistoryForm.controls.clinicalHistory?.dirty) {
                    <div class="invalid-feedback">
                      <p
                        *ngIf="medicalHistoryForm.controls.clinicalHistory?.errors?.['maxlength'] as maxLengthError"
                      >
                        Clinical History cannot be more than
                        {{ maxLengthError.requiredLength }} characters
                      </p>
                      @if(medicalHistoryForm.controls.clinicalHistory?.errors?.['required'])
                      {
                      <p>Clinical History is required</p>
                      }
                      @if(medicalHistoryForm.controls.clinicalHistory?.errors?.['whitespace'])
                      {
                      <p>Clinical History cannot be whitespaces</p>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div class="col col-urgency">
                <div
                  class="d-flex flex-column urgency-level label-and-input"
                  formGroupName="patientMedicalHistory"
                >
                  <label>Urgency Level</label>
                  <div class="checkbox-group">
                    <mat-checkbox id="polytrauma" formControlName="polyTrauma"
                      ><p class="label">PolyTrauma</p></mat-checkbox
                    >
                    <mat-checkbox
                      id="stroke-checkbox"
                      [checked]="
                        medicalHistoryForm.controls.stroke.value !==
                        StrokeQueryType.None
                      "
                      (change)="strokeCheckboxUpdated($event.checked)"
                      ><p class="label">Stroke</p></mat-checkbox
                    >
                  </div>
                  @if(medicalHistoryForm.controls.stroke.value !==
                  StrokeQueryType.None) {
                  <mat-radio-group
                    class="d-flex flex-column stroke-radio-buttons"
                    formControlName="stroke"
                  >
                    <mat-radio-button class="label" value="Thrombectomy"
                      >Thrombectomy</mat-radio-button
                    >
                    <mat-radio-button class="label" value="Thrombolysis"
                      >Thrombolysis</mat-radio-button
                    >
                    <mat-radio-button class="label" value="SimpleStroke"
                      >Simple Stroke</mat-radio-button
                    >
                  </mat-radio-group>
                  @if(medicalHistoryForm.controls.stroke?.touched ||
                  medicalHistoryForm.controls.stroke?.dirty) {
                  <div class="invalid-feedback">
                    @if(medicalHistoryForm.controls.stroke?.errors?.['required'])
                    {
                    <p>Stroke query type is required</p>
                    }
                  </div>
                  }}
                </div>
              </div>
              <div
                class="col d-flex flex-column egfr-paediatric-consult-section"
              >
                <div class="row no-gutters">
                  <div
                    id="egfr"
                    class="d-flex flex-column label-and-input mr-4"
                    formGroupName="patientMedicalHistory"
                  >
                    <label for="egfr">eGFR</label>
                    <mat-radio-group id="egfr" formControlName="egfr">
                      <mat-radio-button
                        class="mr-4 label"
                        value="Unknown"
                        tabIndex="0"
                        >Unknown</mat-radio-button
                      >
                      <mat-radio-button class="label" value="Known" tabIndex="0"
                        >Known</mat-radio-button
                      >
                    </mat-radio-group>
                    @if(medicalHistoryForm.controls.egfr?.touched ||
                    medicalHistoryForm.controls.egfr?.dirty) {
                    <div class="invalid-feedback">
                      @if(medicalHistoryForm.controls.egfr?.errors?.['required'])
                      {
                      <p>eGFR is required</p>
                      }
                    </div>
                    }
                  </div>
                  <div
                    class="d-flex flex-column label-and-input mr-4 egfrResult-section"
                    formGroupName="patientMedicalHistory"
                  >
                    @if(medicalHistoryForm.controls.egfr.value === 'Known') {

                    <label for="egfrResult">eGFR Result *</label>
                    <input
                      formControlName="egfrResult"
                      id="egfrResult"
                      type="text"
                    />
                    @if(medicalHistoryForm.controls.egfrResult?.touched ||
                    medicalHistoryForm.controls.egfrResult?.dirty) {
                    <div class="invalid-feedback">
                      <p
                        *ngIf="medicalHistoryForm.controls.egfrResult?.errors?.['maxlength'] as maxLengthError"
                      >
                        eGFR Result cannot be more than
                        {{ maxLengthError.requiredLength }} characters
                      </p>
                      @if(medicalHistoryForm.controls.egfrResult?.errors?.['required'])
                      {
                      <p>eGFR Result is required</p>
                      }
                      @if(medicalHistoryForm.controls.egfrResult?.errors?.['whitespace'])
                      {
                      <p>eGFR Result cannot be whitespace</p>
                      }
                      @if(medicalHistoryForm.controls.egfrResult?.errors?.['pattern'])
                      {
                      <p>Invalid characters in eGFR Result</p>
                      }
                    </div>
                    } }
                  </div>

                  @if(showPaediatricConsult$ | async) {
                  <ng-container>
                    <div
                      class="d-flex flex-column paediatric-consult label-and-input"
                      formGroupName="patientMedicalHistory"
                      id="paediatricConsult"
                    >
                      <label class="wide-label"
                        >Consultant/Paediatrician Approved</label
                      >
                      <mat-radio-group formControlName="paediatricConsult">
                        <mat-radio-button class="label mr-4" [value]="true">
                          Yes</mat-radio-button
                        >
                        <mat-radio-button class="label" [value]="false"
                          >No</mat-radio-button
                        >
                      </mat-radio-group>
                      @if(medicalHistoryForm.controls.paediatricConsult?.touched
                      || medicalHistoryForm.controls.paediatricConsult?.dirty) {

                      <div class="invalid-feedback">
                        @if(medicalHistoryForm.controls.paediatricConsult?.errors?.['required'])
                        {
                        <p>Selection is required</p>
                        }
                      </div>
                      }
                    </div>
                  </ng-container>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-relevant-priors">
          <div class="section section-relevant-priors">
            <div class="d-flex dotted-underline">
              <h4 class="section-header flex-grow-1">Relevant Priors</h4>
              <button
                type="button"
                class="add-item-button"
                (click)="addEmptyPrior()"
              >
                Add Prior
              </button>
            </div>
            <div class="section-body">
              <table class="table-priors" formArrayName="relevantPriors">
                <thead>
                  <th class="modality-cell">Modality</th>
                  <th class="bodypart-cell">Body Part/Procedure</th>
                  <th class="prior-date-cell">Prior Date</th>
                  <th class="action-cell"></th>
                </thead>
                <tbody>
                  @for(priorGroup of
                  imagingRequestForm.controls.relevantPriors.controls; track
                  index; let index = $index) {
                  <tr [formGroup]="priorGroup">
                    <td class="modality-cell">
                      <mat-select
                        placeholder="-"
                        formControlName="modality"
                        panelClass="imaging-request-dropdown-panel"
                        panelWidth=""
                      >
                        <mat-option [disabled]="true"> - </mat-option>
                        @for(modality of modalityValues$ | async; track
                        modality) {
                        <mat-option
                          [value]="modality"
                          id="option-{{ modality }}"
                        >
                          {{ modality }}
                        </mat-option>
                        }
                      </mat-select>
                      @if(priorGroup['controls']['modality']?.touched ||
                      priorGroup['controls']['modality']?.dirty) {
                      <div class="invalid-feedback">
                        @if(priorGroup['controls']['modality']?.errors?.['required'])
                        {
                        <p>Modality is required</p>
                        }
                      </div>
                      }
                    </td>
                    <td>
                      <mat-select
                        placeholder="-"
                        formControlName="studyDescription"
                        panelClass="imaging-request-dropdown-panel"
                        panelWidth=""
                      >
                        <mat-option [disabled]="true"> - </mat-option>
                        @for(bodyPart of bodyPartValues$ | async; track
                        bodyPart) {
                        <mat-option
                          [value]="bodyPart"
                          id="option-{{ bodyPart }}"
                        >
                          {{ bodyPart }}
                        </mat-option>
                        }
                      </mat-select>
                      @if(priorGroup['controls']['studyDescription']?.touched ||
                      priorGroup['controls']['studyDescription']?.dirty) {
                      <div class="invalid-feedback">
                        @if(priorGroup['controls']['studyDescription']?.errors?.['required'])
                        {
                        <p>Body Part is required</p>
                        }
                      </div>
                      }
                    </td>
                    <td class="prior-date-cell">
                      <div class="date-input-wrapper">
                        <input
                          matInput
                          id="prior-dob"
                          formControlName="studyDate"
                          [matDatepicker]="studyDescriptionDatePicker"
                          [matDatepickerFilter]="isDateBeforeToday"
                          placeholder="DD/MM/YYYY"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="studyDescriptionDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                          #studyDescriptionDatePicker
                        ></mat-datepicker>
                      </div>
                      @if(priorGroup['controls']['studyDate']?.touched ||
                      priorGroup['controls']['studyDate']?.dirty) {
                      <div class="invalid-feedback">
                        @if(priorGroup['controls']['studyDate']?.errors?.['required'])
                        {
                        <p>Prior Date is required</p>
                        }
                      </div>
                      }
                    </td>
                    <td class="action-cell">
                      <mat-icon
                        svgIcon="white-cross"
                        (click)="removePrior(index)"
                      ></mat-icon>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters panel-row">
        <div class="col">
          <div
            id="section-regions-for-scanning"
            class="section regions-for-scanning"
          >
            <div class="d-flex">
              <h4 class="section-header flex-grow-1">Regions for Scanning</h4>
              <button
                type="button"
                class="add-item-button"
                (click)="addEmptyScanRegion()"
              >
                Add Region for Scanning
              </button>
            </div>
            @if(imagingRequestForm.controls.scanRegions.touched ||
            imagingRequestForm.controls.scanRegions.dirty) {
            <div class="invalid-feedback">
              @if(imagingRequestForm.controls.scanRegions.errors?.['required'])
              {
              <p>At least one scan region is required</p>
              }
            </div>
            }
            <div class="section-body">
              <app-scan-regions-form
                [scanRegionControlsArray]="
                  imagingRequestForm.controls.scanRegions
                "
                [modalities]="modalityValues$ | async"
                [bodyParts]="bodyPartValues$ | async"
              >
              </app-scan-regions-form>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mr-1">
      <div class="request-call-with-radiologist">
        <label
          [class]="[
            'request-call-label',
            (clinicalDiscussionIsMandatory$ | async) ||
            hasOpenClinicalDiscussion
              ? ''
              : 'cursor-pointer'
          ]"
          for="toggle-input"
          >Request call with Radiologist?</label
        >
        <app-toggle
          [id]="'clinical-discussion-toggle'"
          [toggleState]="
            hasOpenClinicalDiscussion
              ? 'Yes'
              : (clinicalDiscussionIsMandatory$ | async)
              ? 'Required'
              : ''
          "
          toggleOffLabel="No"
          toggleOnLabel="Yes"
          [disabled]="
            (clinicalDiscussionIsMandatory$ | async) ||
            hasOpenClinicalDiscussion
          "
          (toggled)="buttonToggled($event)"
        ></app-toggle>
      </div>

      <button mat-stroked-button id="close" (click)="close()" type="button">
        Close without Saving
      </button>
      <button
        mat-stroked-button
        id="submit"
        (click)="submit()"
        class="submit-request-button"
        [disabled]="saving || imagingRequestForm.pristine"
        type="submit"
      >
        Submit Request
      </button>
    </mat-dialog-actions>
  </form>
</div>
<div
  *ngIf="hasPendingChanges$ | async"
  id="streaming-notification"
  class="floating-notification clickable alert"
  (click)="mergePendingChanges()"
>
  <fa-icon class="pr-2" [icon]="['fas', 'info-circle']"></fa-icon>
  Details of this request have been updated, please click here to refresh.
</div>
